module.exports = __webpack_public_path__ + "img/19-towards-a-socially-just.b5e67360.jpg";